import { type CSSObject } from '@emotion/react'
import React from 'react'

type ImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  loading?: 'lazy' | 'eager'
  src: string
  css?: CSSObject
}

const Image = React.forwardRef<React.Ref<any>, ImageProps>(
  ({ loading = 'lazy', ...rest }, ref: React.Ref<any>) => {
    return (
      <img ref={ref} loading={loading} {...rest} /> // eslint-disable-line jsx-a11y/alt-text
    )
  }
)

Image.displayName = 'Image'

export default Image
